import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

export function useHelpEmail() {
  const { state } = useManageMyGivingPage();
  const helpEmail = state.pageSettings?.helpEmail;

  const emailToUse =
    helpEmail && String(helpEmail).trim() !== ""
      ? helpEmail
      : "help@flocknote.com";

  return emailToUse;
}
